import { render, staticRenderFns } from "./DetailTemplateBank.vue?vue&type=template&id=27c60b81"
import script from "./DetailTemplateBank.vue?vue&type=script&lang=js"
export * from "./DetailTemplateBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports